module.exports = __webpack_public_path__ + "img/moksir.b37ed4bd.jpg";